/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UndercarriageChangeOutScope } from './UndercarriageChangeOutScope';
import {
    UndercarriageChangeOutScopeFromJSON,
    UndercarriageChangeOutScopeFromJSONTyped,
    UndercarriageChangeOutScopeToJSON,
    UndercarriageChangeOutScopeToJSONTyped,
} from './UndercarriageChangeOutScope';
import type { EquipmentFitmentSpecification } from './EquipmentFitmentSpecification';
import {
    EquipmentFitmentSpecificationFromJSON,
    EquipmentFitmentSpecificationFromJSONTyped,
    EquipmentFitmentSpecificationToJSON,
    EquipmentFitmentSpecificationToJSONTyped,
} from './EquipmentFitmentSpecification';

/**
 * 
 * @export
 * @interface SyncUndercarriageChangeOutRequest
 */
export interface SyncUndercarriageChangeOutRequest {
    /**
     * 
     * @type {string}
     * @memberof SyncUndercarriageChangeOutRequest
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof SyncUndercarriageChangeOutRequest
     */
    sideEquipmentExternalId?: string;
    /**
     * 
     * @type {string}
     * @memberof SyncUndercarriageChangeOutRequest
     */
    changeOutDate?: string;
    /**
     * 
     * @type {number}
     * @memberof SyncUndercarriageChangeOutRequest
     */
    machineHoursAtChangeOut?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SyncUndercarriageChangeOutRequest
     */
    notes?: string;
    /**
     * 
     * @type {UndercarriageChangeOutScope}
     * @memberof SyncUndercarriageChangeOutRequest
     */
    scope?: UndercarriageChangeOutScope;
    /**
     * 
     * @type {number}
     * @memberof SyncUndercarriageChangeOutRequest
     */
    brandManufacturerId?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof SyncUndercarriageChangeOutRequest
     */
    effectiveAt?: Date | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncUndercarriageChangeOutRequest
     */
    removedFitmentExternalIds?: Array<string>;
    /**
     * 
     * @type {Array<EquipmentFitmentSpecification>}
     * @memberof SyncUndercarriageChangeOutRequest
     */
    installedFitments?: Array<EquipmentFitmentSpecification>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncUndercarriageChangeOutRequest
     */
    afterOperations?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncUndercarriageChangeOutRequest
     */
    beforeOperations?: Array<string>;
}



/**
 * Check if a given object implements the SyncUndercarriageChangeOutRequest interface.
 */
export function instanceOfSyncUndercarriageChangeOutRequest(value: object): value is SyncUndercarriageChangeOutRequest {
    return true;
}

export function SyncUndercarriageChangeOutRequestFromJSON(json: any): SyncUndercarriageChangeOutRequest {
    return SyncUndercarriageChangeOutRequestFromJSONTyped(json, false);
}

export function SyncUndercarriageChangeOutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SyncUndercarriageChangeOutRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'sideEquipmentExternalId': json['sideEquipmentExternalId'] == null ? undefined : json['sideEquipmentExternalId'],
        'changeOutDate': json['changeOutDate'] == null ? undefined : json['changeOutDate'],
        'machineHoursAtChangeOut': json['machineHoursAtChangeOut'] == null ? undefined : json['machineHoursAtChangeOut'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'scope': json['scope'] == null ? undefined : UndercarriageChangeOutScopeFromJSON(json['scope']),
        'brandManufacturerId': json['brandManufacturerId'] == null ? undefined : json['brandManufacturerId'],
        'effectiveAt': json['effectiveAt'] == null ? undefined : (new Date(json['effectiveAt'])),
        'removedFitmentExternalIds': json['removedFitmentExternalIds'] == null ? undefined : json['removedFitmentExternalIds'],
        'installedFitments': json['installedFitments'] == null ? undefined : ((json['installedFitments'] as Array<any>).map(EquipmentFitmentSpecificationFromJSON)),
        'afterOperations': json['afterOperations'] == null ? undefined : json['afterOperations'],
        'beforeOperations': json['beforeOperations'] == null ? undefined : json['beforeOperations'],
    };
}

export function SyncUndercarriageChangeOutRequestToJSON(json: any): SyncUndercarriageChangeOutRequest {
    return SyncUndercarriageChangeOutRequestToJSONTyped(json, false);
}

export function SyncUndercarriageChangeOutRequestToJSONTyped(value?: SyncUndercarriageChangeOutRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'externalId': value['externalId'],
        'sideEquipmentExternalId': value['sideEquipmentExternalId'],
        'changeOutDate': value['changeOutDate'],
        'machineHoursAtChangeOut': value['machineHoursAtChangeOut'],
        'notes': value['notes'],
        'scope': UndercarriageChangeOutScopeToJSON(value['scope']),
        'brandManufacturerId': value['brandManufacturerId'],
        'effectiveAt': value['effectiveAt'] === null ? null : ((value['effectiveAt'] as any)?.toISOString()),
        'removedFitmentExternalIds': value['removedFitmentExternalIds'],
        'installedFitments': value['installedFitments'] == null ? undefined : ((value['installedFitments'] as Array<any>).map(EquipmentFitmentSpecificationToJSON)),
        'afterOperations': value['afterOperations'],
        'beforeOperations': value['beforeOperations'],
    };
}

